import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./StatsFilter.styles";
import { FormDateField } from "../../../../components/FormComponents/FormDateField";
import { convertDateStringToNumber, mapNumberToDate } from "../../../../../utilities/dateTimeUtils";
import { DATE_FORMAT } from "../../../../../constants/TIME";
import { StatsFilterOption } from "./StatsFilterSection";
import Grid, { GridSize } from "@material-ui/core/Grid/Grid";
import { BlueButton } from "../../../../components/Buttons/BlueButton";

export type IStatsFilterOptionType = "orderType" | "orderState" | "paymentMethod" | "users";

export type IStatsFilters = {
    [key in IStatsFilterOptionType]: string[];
};

export const orderTypes = ["INTERNAL", "B2B"];
export const orderStates = ["Registered", "Confirmed", "Processing", "Completed", "Failed", "Rejected"];
export const paymentMethods = ["Card", "Bank Transfer", "Quota"];
export const userTypes = ["Internal", "External"];

export interface IFilterSection {
    name: IStatsFilterOptionType;
    title: string;
    options: string[];
    gridSize: GridSize;
}
const allFilterSections: IFilterSection[] = [
    {
        name: "orderType",
        title: "Order type",
        options: orderTypes,
        gridSize: 5
    },
    {
        name: "orderState",
        title: "Order state",
        options: orderStates,
        gridSize: 12
    },
    {
        name: "paymentMethod",
        title: "Payment Method",
        options: paymentMethods,
        gridSize: 5
    },
    {
        name: "users",
        title: "Users",
        options: userTypes,
        gridSize: 4
    }
];

export const getStatFilterDef = (name: IStatsFilterOptionType): IFilterSection => {
    return allFilterSections.find(section => section.name === name);
};

export interface IStatsFilterProps extends WithStyles<typeof styles> {
    from: number;
    to: number;
    onFromChange: (value: number) => void;
    onToChange: (value: number) => void;
    filters: IStatsFilters;
    onFiltersChange: (type: IStatsFilterOptionType, values: string[]) => void;
    shownFilters: IStatsFilterOptionType[];
    onUpdate: () => void;
    isUpdateButtonEnabled: boolean;
}

const StatsFilterPure: React.FunctionComponent<IStatsFilterProps> = ({
    classes,
    from,
    to,
    onFromChange,
    onToChange,
    filters,
    onFiltersChange,
    shownFilters,
    onUpdate,
    isUpdateButtonEnabled
}: IStatsFilterProps) => {
    return (
        <Paper variant="outlined" className={classes.paper}>
            <Grid container spacing={3}>
                <Grid item>
                    <Typography variant={"h6"}>Date from</Typography>
                    <FormDateField
                        helperText=""
                        placeholder="Start Date"
                        value={mapNumberToDate(from).format(DATE_FORMAT)}
                        onChange={newFrom => onFromChange(convertDateStringToNumber(newFrom))}
                        disabled={false}
                    />
                </Grid>
                <Grid item>
                    <Typography variant={"h6"}>Date to</Typography>
                    <FormDateField
                        helperText=""
                        placeholder="End Date"
                        value={mapNumberToDate(to).format(DATE_FORMAT)}
                        onChange={newTo => onToChange(convertDateStringToNumber(newTo))}
                        disabled={false}
                    />
                </Grid>
            </Grid>
            {allFilterSections
                .filter(aF => shownFilters.includes(aF.name))
                .map(filter => {
                    return (
                        <StatsFilterOption
                            key={filter.name}
                            filter={filter}
                            selectedValues={filters[filter.name]}
                            onChange={(name, newValues) => onFiltersChange(name, newValues)}
                        />
                    );
                })}
            <BlueButton
                onClick={onUpdate}
                disabled={!isUpdateButtonEnabled}
                style={{ paddingRight: 30, paddingLeft: 30 }}
            >
                Update
            </BlueButton>
        </Paper>
    );
};

export const StatsFilter = withStyles(styles)(StatsFilterPure);
